export const environment = {
  production: false,
  apiUrl: 'https://gateway-t.erp-devapi.com/',
  aiBaseUrl: 'https://tenant-py.erp-devapi.com/',
  /** Dev: allow local demo hosts. Production should set an explicit allowlist. */
  allowedOrigins: [
    'http://localhost:4200',
    'http://127.0.0.1:4200',
    'null', // file:// demo pages report origin as "null"
  ] as string[],
};
